import React from 'react';
import { Card } from '../ui/Card';
import { Quote } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Johnson',
  role: 'Masters in Data Science',
  uni: 'University of Manchester, UK',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
  quote: "Study Board made my dream of studying in the UK a reality. Their guidance on the visa process was invaluable, and I couldn't have done it without them."
}, {
  name: 'Michael Chen',
  role: 'BSc Computer Science',
  uni: 'University of Toronto, Canada',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
  quote: 'The team was incredibly supportive throughout the entire application process. They helped me choose the right university and even helped with accommodation.'
}, {
  name: 'Priya Patel',
  role: 'MBA',
  uni: 'Monash University, Australia',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
  quote: "Professional, knowledgeable, and friendly. They took the stress out of the application process and helped me secure a scholarship I didn't know existed."
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-[#faf8f5]" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center mb-16" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-119">
            Student Success Stories
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-120">
            Don't just take our word for it. Hear from students who have
            successfully started their international education journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-121">
          {testimonials.map(testimonial => <Card key={testimonial.name} className="relative h-full" data-id="element-122">
              <Quote className="absolute top-6 right-6 h-8 w-8 text-gray-100" data-id="element-123" />
              <div className="flex flex-col h-full" data-id="element-124">
                <div className="flex-1 mb-6" data-id="element-125">
                  <p className="text-gray-600 italic leading-relaxed" data-id="element-126">
                    "{testimonial.quote}"
                  </p>
                </div>
                <div className="flex items-center pt-6 border-t border-gray-100" data-id="element-127">
                  <img src={testimonial.image} alt={testimonial.name} className="h-12 w-12 rounded-full object-cover mr-4 ring-2 ring-[#f59e0b]/20" data-id="element-128" />
                  <div data-id="element-129">
                    <h4 className="font-bold text-[#1e3a5f]" data-id="element-130">
                      {testimonial.name}
                    </h4>
                    <p className="text-xs text-[#f59e0b] font-medium" data-id="element-131">
                      {testimonial.role}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-132">{testimonial.uni}</p>
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}